import { IBEngLogResponse } from "./../../typings/board/ControllerResponse";
import { IPromise, IHttpPromise, IHttpService } from "angular";
import { IFileEntry } from "../../typings/board/Models";
import { IBEngLogMode, IBEngLogEncryptionArgs } from "../../typings/board/Admin";

export interface ISortOptions {
    page: number;
    take: number;
    pageSize: number;
    skip: number;
}

export interface IBlobResult {
    blob: Blob;
    error: string;
}

export const BENG_LOGS_SERVICE = "bengLogsService";

export class BEngLogsService {

    static $inject = ["$q", "$http", "WEB_ENDPOINT"];

    constructor(private $q: ng.IQService, private $http: IHttpService, private boardWebEndpoint) { }

    logs(): IPromise<IBEngLogResponse> {
        return this.$http.get<IBEngLogResponse>(`api/BEngLog/get`).then(response => {
            return response.data;
        });
    }

    downloadAll() {
        return this.$http.get<any>(`api/BEngLog/downloadall`, {
            responseType: "arraybuffer",
            cache: false
        }).then(response => {
            return new Blob([response.data], { type: "application/zip" });
        });
    }

    download(files: IFileEntry[]): IPromise<IBlobResult> {
        return this.$http.post<any>(`api/BEngLog/download`, files /*this.purgeFileModel(files)*/, {
            responseType: "arraybuffer",
            cache: false
        }).then((response) => {
        let result: IBlobResult = { blob: null, error: "" };
        if (response.status !== 200) {
            result.error = response.statusText;
            return this.$q.reject(result);
        }
        result.blob = new Blob([response.data], { type: "application/zip" });
        return this.$q.resolve(result);

        }, (reason: any) => {
            return this.$q.reject(reason.statusText);
        });
    }

    clearAll(): IHttpPromise<void> {
        return this.$http.get<void>("api/BEngLog/deleteall");
    }

    clear(files: IFileEntry[]): IHttpPromise<any> {
        return this.$http.post<any>("api/BEngLog/delete", files/*this.purgeFileModel(files)*/).then((response) => {
            return this.$q.resolve(response.data);
        }, (reason) => {
            return this.$q.reject(reason.data);
        });
    }

    getConfigurations() {
        return this.$http.get<IBEngLogMode[]>(`${this.boardWebEndpoint}/admin/log/getConfigurations`).then(response => response.data);
    }

    setConfigurations(modes: IBEngLogMode[]) {
        return this.$http.post(`${this.boardWebEndpoint}/admin/log/setConfigurations`, modes);
    }

    enableEncryption(args: IBEngLogEncryptionArgs) {
        return this.$http.post(`${this.boardWebEndpoint}/admin/log/enableEncryption`, args);
    }

    disableEncryption(args: IBEngLogEncryptionArgs) {
        return this.$http.post(`${this.boardWebEndpoint}/admin/log/disableEncryption`, args);
    }

    updateEncryptionPassword(args: IBEngLogEncryptionArgs) {
        return this.$http.post(`${this.boardWebEndpoint}/admin/log/updateEncryptionPassword`, args);
    }

    downloadDecrypter() {
        return this.$http.get<any>(`api/BEngLog/Decrypter`, {
            responseType: "arraybuffer",
            cache: false
        }).then(response => {
            return new Blob([response.data], { type: "application/zip" });
        });
    }
}


// WEBPACK FOOTER //
// ./app/beng-logs/beng-logs.service.ts